var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.user_token)?_c('reset-password',{attrs:{"user_token":_vm.user_token,"resetBy":'user_token'}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }